(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 13173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51776);
/* harmony import */ var _helpers_unitConverter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52712);
/* harmony import */ var _helpers_animation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80613);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



var moon = (0,_helpers_animation__WEBPACK_IMPORTED_MODULE_1__/* .createAnimation */ .i)("MoonLoader", "100% {transform: rotate(360deg)}", "moon");
function MoonLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? 60 : _f, additionalprops = __rest(_a, ["loading", "color", "speedMultiplier", "cssOverride", "size"]);
    var _g = (0,_helpers_unitConverter__WEBPACK_IMPORTED_MODULE_2__/* .parseLengthAndUnit */ .h)(size), value = _g.value, unit = _g.unit;
    var moonSize = value / 7;
    var wrapper = __assign({ display: "inherit", position: "relative", width: "".concat("".concat(value + moonSize * 2).concat(unit)), height: "".concat("".concat(value + moonSize * 2).concat(unit)), animation: "".concat(moon, " ").concat(0.6 / speedMultiplier, "s 0s infinite linear"), animationFillMode: "forwards" }, cssOverride);
    var ballStyle = function (size) {
        return {
            width: (0,_helpers_unitConverter__WEBPACK_IMPORTED_MODULE_2__/* .cssValue */ .E)(size),
            height: (0,_helpers_unitConverter__WEBPACK_IMPORTED_MODULE_2__/* .cssValue */ .E)(size),
            borderRadius: "100%",
        };
    };
    var ball = __assign(__assign({}, ballStyle(moonSize)), { backgroundColor: "".concat(color), opacity: "0.8", position: "absolute", top: "".concat("".concat(value / 2 - moonSize / 2).concat(unit)), animation: "".concat(moon, " ").concat(0.6 / speedMultiplier, "s 0s infinite linear"), animationFillMode: "forwards" });
    var circle = __assign(__assign({}, ballStyle(value)), { border: "".concat(moonSize, "px solid ").concat(color), opacity: "0.1", boxSizing: "content-box", position: "absolute" });
    if (!loading) {
        return null;
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", __assign({ style: wrapper }, additionalprops),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { style: ball }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { style: circle })));
}
/* harmony default export */ __webpack_exports__["Z"] = (MoonLoader);


/***/ }),

/***/ 80613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ createAnimation; }
/* harmony export */ });
var createAnimation = function (loaderName, frames, suffix) {
    var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
    if (typeof window == "undefined" || !window.document) {
        return animationName;
    }
    var styleEl = document.createElement("style");
    document.head.appendChild(styleEl);
    var styleSheet = styleEl.sheet;
    var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
    if (styleSheet) {
        styleSheet.insertRule(keyFrames, 0);
    }
    return animationName;
};


/***/ }),

/***/ 52712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ cssValue; },
/* harmony export */   "h": function() { return /* binding */ parseLengthAndUnit; }
/* harmony export */ });
var cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true,
};
/**
 * If size is a number, append px to the value as default unit.
 * If size is a string, validate against list of valid units.
 * If unit is valid, return size as is.
 * If unit is invalid, console warn issue, replace with px as the unit.
 *
 * @param {(number | string)} size
 * @return {LengthObject} LengthObject
 */
function parseLengthAndUnit(size) {
    if (typeof size === "number") {
        return {
            value: size,
            unit: "px",
        };
    }
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) {
        value = parseFloat(valueString);
    }
    else {
        value = parseInt(valueString, 10);
    }
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if (cssUnit[unit]) {
        return {
            value: value,
            unit: unit,
        };
    }
    console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
    return {
        value: value,
        unit: "px",
    };
}
/**
 * Take value as an input and return valid css value
 *
 * @param {(number | string)} value
 * @return {string} valid css value
 */
function cssValue(value) {
    var lengthWithunit = parseLengthAndUnit(value);
    return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}


/***/ }),

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(78828);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CardNotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61097);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41272);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56562);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);






const CardNotFound = ({ useSmallIcon =false , useMaxWidth =0 , ...props })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const { title , message , useButton , src , className =""  } = props;
    const pushToTrackEvents = (label)=>{
        switch(label){
            case "Mulai Belajar Gratis":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "myclass_startlearning_a"
                });
                break;
            case "Kembali ke Homepage":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_404_back_to_homepage_a"
                });
                break;
            case "Coba Lagi":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_500_retry_a"
                });
                router.reload();
                break;
            case "Kembali":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_500_back_a"
                });
                router.back();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `w-full flex ${useSmallIcon ? "flex-row justify-left" : "flex-col justify-center"} text-center gap-24 items-center m-auto ${className} ${useMaxWidth ? "bg-light_neutral10_to_dark_neutral50 min-h-[320px] rounded-8" : ""}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src ? src : "/images/icon-not-found.png",
                alt: "",
                width: useSmallIcon ? 80 : 120,
                height: useSmallIcon ? 80 : 120
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `flex flex-col gap-24 ${useMaxWidth ? `max-w-[${useMaxWidth}px] px-16 md:px-0` : ""}`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${useSmallIcon ? "grid align-center gap-4" : "flex flex-col gap-8"}`,
                        children: [
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-b1 font-bold ${useSmallIcon ? "text-left" : ""}`,
                                children: title
                            }),
                            message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-b2 font-medium text-neutral-60 ${useSmallIcon ? "text-left" : ""}`,
                                children: message
                            })
                        ]
                    }),
                    useButton && useButton.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center " + (useButton.length > 1 ? "gap-8" : ""),
                        children: useButton.map((el)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: el.href,
                                onClick: ()=>{
                                    pushToTrackEvents(el.label);
                                    if (el.onClose) {
                                        el.onClose();
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    size: "medium",
                                    isFull: true,
                                    //@ts-ignore
                                    variant: el.variant ? el.variant : "primary",
                                    children: el.label
                                })
                            }, "useButton" + el.href))
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 35824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ContainerDesktop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var modules_Nav_BottomNav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51396);
/* harmony import */ var react_spinners__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13173);
/* harmony import */ var lib_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59799);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






const Container = ({ children , className ="" , wrapperClassName ="" , useNavbar =false , isLoader =false , useLoader =false  })=>{
    const isDesktop = (0,lib_device__WEBPACK_IMPORTED_MODULE_3__/* .useIsDesktop */ .Ce)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            "bg-light_neutral10_to_dark_neutral50",
            wrapperClassName
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: [
                    "relative max-w-container mx-auto bg-white ",
                    className
                ].join(" "),
                children: [
                    children,
                    useLoader && isLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex w-full items-center justify-center h-[80vh]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spinners__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            loading: isLoader
                        })
                    })
                ]
            }),
            useNavbar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_Nav_BottomNav__WEBPACK_IMPORTED_MODULE_2__/* .BottomNav */ .L, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);
const ContainerDesktop = ({ children , className ="" , classBackgroundFull ="" , useMinHeight =false , useAuto =false , customStyle =null  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `w-full ${useMinHeight ? "min-h-content" : "h-full"} ` + (classBackgroundFull ? classBackgroundFull : " bg-transparent"),
        style: customStyle != null ? customStyle : null,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            // className={`mx-auto !max-w-[1366px] w-[95%] ${
            className: `${useAuto ? "mx-auto !max-w-[1366px] w-[100%] " : "md:px-20"} ${classBackgroundFull ? "relative h-full" : ""} ${className}`,
            children: children ?? null
        })
    });
};


/***/ }),

/***/ 78828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(35824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
// EXTERNAL MODULE: ./src/components/Card/CardNotFound.tsx
var CardNotFound = __webpack_require__(47313);
;// CONCATENATED MODULE: ./src/pages_web/404.tsx




const NotFoundData = [
    {
        id: "500",
        title: "Ups, Ada Gangguan yang Terjadi",
        message: "Kami sedang membereskan masalah ini. Silahkan kembali ke halaman sebelumnya atau mencoba sesaat lagi",
        src: "/images/icon-warning.png",
        useButton: [
            {
                href: "/",
                label: "Kembali",
                variant: "secondary_transparant"
            },
            {
                href: "/",
                label: "Coba Lagi"
            }
        ]
    },
    {
        id: "404",
        title: "Halaman Tidak Ditemukan",
        message: null,
        src: "/images/icon-404.png",
        useButton: [
            {
                href: "/",
                label: "Kembali ke Homepage"
            }
        ]
    }
];
const Page404 = ()=>{
    const notFoundProps = NotFoundData.find((x)=>x.id === "404");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "h-screen !max-w-[100vw] flex justify-center px-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                    ...notFoundProps
                })
            })
        })
    });
};
/* harmony default export */ var _404 = (Page404);

;// CONCATENATED MODULE: ./src/pages/404.tsx



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6562,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);